import React, { useState } from "react";
import AccordianItem from "./AccordianItem";
import { BANKING_ACCORDIAN_1 } from "../utils/courseConifg";
import { IMAGES } from "../utils/images";
import '../Styles/AccordionSection.css'

const Accordian = ({list,image}) => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <>
      <div className="accordion-section">
        <div className="accordian-left">
            <h1 className="accordion-section-heading">What You’ll Learn?</h1>
            {/* <p className="faq-section-body">We follow a structured process, starting with in-depth discovery to identify key problems, defining clear objectives, and prototyping innovative solutions. Through evaluation and iterative refinement, we develop exceptional products that deliver value and meet business goals.</p> */}

          <div className="accordion-section-bottom">
            {list?.map((item, index, self) => {
              return (
                <AccordianItem
                  key={item.id}
                  {...item}
                  isOpen={index === openIndex ? true : false}
                  setIsOpen={() => {
                    index === openIndex
                      ? setOpenIndex(null)
                      : setOpenIndex(index);
                  }}
                />
              );
            })}
          </div>
        </div>
        <img src={image} />
      </div>
    </>
  );
};

export default Accordian;
